import {Button} from '@luminopia/react-toolbox/lib/button'
import Confirm from 'core/components/confirm'
import * as React from 'react'
import * as classNames from './subject-controls.css'
import { deactivatePrescriptionFormFactory } from './deactivate-prescription-form'

export interface IProps {
  className?: string

  deactivateButton: boolean
  reactivateButton: boolean
  isConfirmActive: boolean
  onConfirmActivate: () => void
  onConfirmDeactivate: () => void
  onDeactivate: ({ reason }: { reason: string }) => void
  onReactivate: () => void
  updatePrescriptionRoute: string
}

interface IComponentState {
  intendsToDeactivate: boolean
}

const formName = 'DeactivatePrescriptionForm'
const DeactivatePrescriptionForm = deactivatePrescriptionFormFactory(formName)

export class SubjectControls extends React.PureComponent<IProps, IComponentState> {
  public state = {
    intendsToDeactivate: false,
  }
  public static defaultProps = {
    deactivateButton: false,
    isConfirmActive: false,
    onConfirmActivate: () => undefined,
    onConfirmDeactivate: () => undefined,
    onDeactivate: ({ reason }: { reason: string }) => undefined,
    onReactivate: () => undefined,
  }

  public render() {
    // TODO I18N
    return (
      <div className={classNames.buttonsContainer}>
        {this.props.deactivateButton && (
          <React.Fragment>
            <Button
              className={classNames.button}
              raised primary
              label='deactivate treatment'
              onClick={this.toggleDeactivationIntention}
              disabled={this.state.intendsToDeactivate}
            />
            {this.state.intendsToDeactivate && (
              <DeactivatePrescriptionForm onSubmit={this.props.onDeactivate} onCancel={this.toggleDeactivationIntention} />
            )}
          </React.Fragment>
        )}
        {this.props.reactivateButton && (
          <React.Fragment>
            <Button
              className={classNames.button}
              raised primary
              label='reactivate treatment'
              onClick={this.props.onConfirmActivate}
            />
            <Confirm
              title='Reactivate treatment?'
              active={this.props.isConfirmActive}
              onConfirm={this.props.onReactivate}
              onCancel={this.props.onConfirmDeactivate}
            >
              Are you sure you want to reactivate treatment for this subject?
            </Confirm>
          </React.Fragment>
        )}
      </div>
    )
  }

  private toggleDeactivationIntention = () => {
    this.setState({intendsToDeactivate: !this.state.intendsToDeactivate})
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/subjects/subject-controls.tsx